<template>
  <div class="title-warpper flex align-center justify-between padding-tb-xs">
    <div class="title-text flex align-center">
      <i class="iconfont icon-home"></i>
      <p v-html="pageTitle"></p>
    </div>
    <el-button size="small" type="primary" v-if="isBack" @click="back">
      返回上一页
    </el-button>
  </div>
</template>

<script>
export default {
  name: "title-modular",
  data() {
    return {}
  },
  props:{
    pageTitle:{
      type:String,
      default:''
    },
    isBack:{
      type:Boolean,
      default:false
    }
  },
  methods:{
    back(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
.title-warpper{
  display: flex;
  align-items: center;
  height: 60px;
  font-size: 15px;
  .title-text{
    color: #667fa0;
    i{
      font-size: 20px;
      margin-right: 5px;
    }
  }
}
</style>